import type { StationId } from "@frontier/content/stations";
import type { SectorId } from "@frontier/content/world-layout";

export const GALAXY_CHART_SIZE = { width: 1200, height: 1080 };

// Chart positions describe the gate network, independently of simulation coordinates.
export const GALAXY_REGION_POSITIONS: Readonly<Record<SectorId, { x: number; y: number }>> = {
  training: { x: 50, y: 0 },
  patrol: { x: 50, y: 46 },
  wrecks: { x: 50, y: 60 },
  frontier: { x: 67, y: 60 },
  "concord-azure": { x: 38, y: 48 },
  "concord-kepler": { x: 25, y: 39 },
  "concord-beacons": { x: 32, y: 24 },
  "concord-aegis": { x: 20, y: 15 },
  "concord-harmony": { x: 8, y: 23 },
  "helion-iron": { x: 38, y: 71 },
  "helion-slag": { x: 25, y: 64 },
  "helion-forge": { x: 17, y: 77 },
  "helion-imperative": { x: 10, y: 89 },
  "helion-rift": { x: 27, y: 94 },
  "nomads-magpie": { x: 78, y: 49 },
  "nomads-graveyard": { x: 90, y: 58 },
  "nomads-mist": { x: 88, y: 73 },
  "nomads-shards": { x: 77, y: 85 },
  "nomads-last-chance": { x: 92, y: 94 },
};

export const GALAXY_FACTION_HEADINGS = {
  concord: { x: 20, y: 6 },
  helion: { x: 18, y: 56 },
  nomads: { x: 85, y: 39 },
};

export function galaxyLinkPath(fromId: string, toId: string, a: { x: number; y: number }, b: { x: number; y: number }): string {
  const ax = a.x * 10, ay = a.y * 10, bx = b.x * 10, by = b.y * 10;
  if (fromId === "concord-beacons" && toId === "helion-forge")
    return `M${ax} ${ay} Q-80 450 ${bx} ${by}`;
  if (fromId === "helion-forge" && toId === "concord-beacons")
    return `M${ax} ${ay} Q-50 450 ${bx} ${by}`;
  if (fromId === "helion-forge" && toId === "nomads-mist")
    return `M${ax} ${ay} C340 810 670 820 ${bx} ${by}`;
  if (fromId === "nomads-mist" && toId === "helion-forge")
    return `M${ax} ${ay} C670 835 340 825 ${bx} ${by}`;
  return `M${ax} ${ay} Q${(ax + bx) / 2 - (by - ay) * .035} ${(ay + by) / 2 + (bx - ax) * .035} ${bx} ${by}`;
}

export const STATION_CHART_POSITIONS: Readonly<Record<StationId, { x: number; y: number }>> = {
  "training-dock": { x: 60, y: 4 },
  meridian: { x: 59, y: 38 }, harmony: { x: 3, y: 33 },
  "helion-base": { x: 38, y: 94 }, "last-chance": { x: 96, y: 84 },
};
